import React, { useMemo, useEffect, useState, useCallback } from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { AuthingButton } from "../../../../components/AuthingButton";
import { Link } from "../../../../components/LinkIcon";

const isWindow = () => typeof window !== "undefined";
const isDocument = () => typeof document !== "undefined";
export const ManufacturingAdvantage = () => {
  const { t } = useTranslation();
  const list = useMemo(() => {
    return [
      {
        title: t("finance.advantage.item1.title"),
        desc: t("finance.advantage.item1.desc"),
        imgUrl:
          "https://files.authing.co/authing-website/finance-advantage-1.png",
        alt: t("finance.advantage.item1.alt"),
        downText: t("common.button.linkDoc"),
        downUrl: "https://docs.authing.cn/v2/guides/sync-new/",
      },
      {
        title: t("finance.advantage.item2.title"),
        desc: t("finance.advantage.item2.desc"),
        imgUrl:
          "https://files.authing.co/authing-website/finance-advantage-2.png",
        alt: t("finance.advantage.item2.alt"),
        downText: t("common.button.linkDoc"),
        downUrl:
          "https://docs.authing.cn/v3/reference/mobile/sdk-for-csharp/management/AclManagementClient.html",
      },
      {
        title: t("finance.advantage.item3.title"),
        desc: t("finance.advantage.item3.desc"),
        imgUrl:
          "https://files.authing.co/authing-website/finance-advantage-3.png",
        alt: t("finance.advantage.item3.alt"),
        downText: t("common.button.see-more"),
        downUrl: "https://www.authing.cn/solutions/ad",
      },
      {
        title: t("finance.advantage.item4.title"),
        desc: t("finance.advantage.item4.desc"),
        imgUrl:
          "https://files.authing.co/authing-website/finance-advantage-4.png",
        alt: t("finance.advantage.item4.alt"),
        downText: t("common.button.see-more"),
        downUrl:
          "https://www.authing.cn/blog/435?keyword=%E9%A3%8E%E6%8E%A7&page=1",
      },
    ];
  }, [t]);
  const [topValue, setTopValue] = useState("0px");
  const [bottomValue, setBottomValue] = useState();
  const [scrollTop, setScrollTop] = useState(0);
  const [bannerIndex, setBannerIndex] = useState(0);
  const scrollHandler = useCallback(() => {
    if (isDocument()) {
      const chrildElement =
        isDocument() && document.querySelector(".bannerBox-right-chrild");
      const documentScrollTop =
        (isDocument() && document.body.scrollTop) ||
        document.documentElement.scrollTop;
      const selfHeight =
        isWindow() &&
        Number(window.getComputedStyle(chrildElement).height.split("px")[0]);
      if (topValue < documentScrollTop) {
        const index = Math.round((documentScrollTop - topValue) / selfHeight);
        if (index < list.length) {
          setBannerIndex(index);
        }
      }
      setScrollTop(documentScrollTop);
    }
  });
  const [element, setElement] = useState(0);
  useEffect(() => {
    scrollHandler();
  }, [scrollHandler]);
  useEffect(() => {
    isWindow() && window.addEventListener("scroll", scrollHandler);
    return () => {
      isWindow() && window.removeEventListener("scroll", scrollHandler);
    };
  }, [scrollHandler]);
  useEffect(() => {
    if (isWindow()) {
      const bannerBox = document.getElementById("bannerBox");
      if (bannerBox) {
        setTopValue(bannerBox.offsetTop);
        setBottomValue(
          isWindow() &&
            Number(window.getComputedStyle(bannerBox).height.split("p")[0]) +
              topValue,
          +"px"
        );
      }
    }
  }, [scrollHandler, topValue]);
  const clientHeight =
    (isDocument() && document.documentElement.clientHeight) || "";
  const cls = classNames({
    "bannerBox-left": true,
    fixed:
      scrollTop + 80 > topValue && scrollTop + clientHeight < bottomValue
        ? true
        : false,
    bottom: scrollTop + clientHeight > bottomValue ? true : false,
  });
  const renderScrollScreenPC = () => {
    return (
      <div className="manufacturing-advantage-pc">
        <div className="banner-connection" id="bannerBox">
          <div className={cls}>
            <div className="index-box">
              {list.map((item, index) => {
                return (
                  <li
                    className={bannerIndex === index ? "li" : ""}
                    key={item.title}
                  ></li>
                );
              })}
            </div>
            <div className="info-box">
              {list.map((item, index) => {
                return (
                  <div
                    className="info-box-item"
                    key={"info-box" + index}
                    style={
                      bannerIndex === index
                        ? { display: "block" }
                        : { display: "none" }
                    }
                  >
                    <div className="info-box-item-title">{item.title}</div>
                    <div className="info-box-blue-gap"></div>
                    <div className="info-box-item-content">{item.desc}</div>
                    {/* {
                        <Link href={item.docLink} target="_blank">
                          {t("common.button.linkDoc")}
                        </Link>
                      } */}
                    <AuthingButton
                      mode="small"
                      onClick={() => {
                        window.open(item.downUrl);
                      }}
                    >
                      {item.downText}
                    </AuthingButton>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="bannerBox-list">
            {list.map((item, index) => {
              return (
                <div key={"bannerBox-right" + index}>
                  <div className="bannerBox-right">
                    <div className="bannerBox-right-chrild">
                      <img
                        src={item.imgUrl}
                        alt={item.alt}
                        style={{ zIndex: "2" }}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  };
  return (
    <div className="manufacturing-advantage manufacturing-column">
      {renderScrollScreenPC()}
      {/* {renderScrollScreenMobile()} */}
    </div>
  );
};
